// Components
import { U21Spacer } from 'app/shared/u21-ui/components';
import { U21SideMenu } from 'app/shared/u21-ui/components/dashboard';

// Models
import { FilingsBatchDefinition } from 'app/modules/sidebar/models';

// Contexts
import { useFetchFilingsGrouped } from 'app/modules/fincenCtr/queries/useFetchFilingsGrouped';
import { ReportType } from 'app/modules/filings/constants';
import { IconDownload } from '@u21/tabler-icons';
import { formatDate } from 'app/shared/utils/date';
import { useDownloadFilingsBatch } from 'app/modules/fincenCtr/queries/useDownloadFilingsBatch';
import {
  createCtrFilterPayload,
  useCtrPageFilters,
} from 'app/modules/fincenCtr/utils';
import { CTR_FILING_FILTER_KEYS } from 'app/modules/fincenCtr/filters';
import { FILTER_OPERATOR } from 'app/modules/filters/constants';
import { SidebarDataRow } from 'app/modules/sidebar/components/utils/SidebarDataRow';

interface OwnProps {
  data: FilingsBatchDefinition['data'];
}

export const SidebarFincenCtr = ({
  data: { id: batchId, pageType },
}: OwnProps) => {
  const pageFilters = useCtrPageFilters(pageType);
  const { data: batchData, isLoading } = useFetchFilingsGrouped({
    limit: 1,
    offset: 1,
    report_type: ReportType.FINCEN_CTR,
    filters: createCtrFilterPayload([
      ...pageFilters,
      {
        key: 'batch_id',
        operator: FILTER_OPERATOR.IS,
        value: batchId,
      },
    ]).filter((f) => f.key !== CTR_FILING_FILTER_KEYS.STATUS),
  });

  const { mutate: downloadFiling, isPending: downloadingBatch } =
    useDownloadFilingsBatch(batchId);

  const filingInfo = batchData?.filings?.[0];

  const {
    total,
    earliest,
    latest,
    accepted,
    rejected,
    created_by: createdBy,
  } = filingInfo ?? {};

  return (
    <U21SideMenu
      title={`Batch ${batchId}`}
      actionButtonProps={{
        children: 'Download Batch',
        endIcon: <IconDownload />,
        loading: downloadingBatch,
      }}
      onAction={() => downloadFiling()}
      loading={isLoading}
    >
      <U21Spacer>
        <SidebarDataRow label="Total filings" showEmptyFields>
          {total}
        </SidebarDataRow>
        <SidebarDataRow label="Accepted filings" showEmptyFields>
          {accepted}
        </SidebarDataRow>
        <SidebarDataRow label="Rejected filings" showEmptyFields>
          {rejected}
        </SidebarDataRow>
        <SidebarDataRow label="Date range" showEmptyFields>
          {`${formatDate(earliest) || 'N/A'} - ${formatDate(latest) || 'N/A'}`}
        </SidebarDataRow>
        <SidebarDataRow label="Created by" showEmptyFields>
          {createdBy}
        </SidebarDataRow>
      </U21Spacer>
    </U21SideMenu>
  );
};
